import { media } from "@features/adaptive/breakpoints";
import { Typography } from "@packages/uiKit";
import Image from "next/image";
import styled from "styled-components";

export const StyledBanner = styled.div`
  height: 344px;
  background: rgb(225, 194, 125);
  background: linear-gradient(
    90deg,
    rgba(225, 194, 125, 1) 0%,
    rgba(216, 180, 108, 1) 18%,
    rgba(237, 210, 146, 1) 37%,
    rgba(232, 201, 130, 1) 53%,
    rgba(234, 194, 121, 1) 67%,
    rgba(234, 156, 83, 1) 80%,
    rgba(234, 156, 83, 1) 100%
  );
  border-radius: 18px;
  padding: 62px 100px;

  display: flex;
  align-items: center;
  gap: 20px;

  ${media.down("desktop")} {
    gap: 0;
    padding: 0;
    height: auto;
    flex-direction: column-reverse;
    align-items: flex-start;
    padding: 40px 30px;
  }
`;

export const StyledTitle = styled(Typography).attrs({
  weight: 400,
  color: "white",
})`
  font-size: 56px;
  width: 700px;
  min-width: 0;
  ${media.down("desktop")} {
    font-size: 28px;
    width: auto;
    margin-top: 40px;
  }
`;

export const StyledTextContainer = styled.div`
  ${media.down("desktop")} {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledDescription = styled(Typography).attrs({
  size: 18,
  weight: 400,
  color: "white",
})`
  width: 665px;
  margin-top: 50px;
  min-width: 0;
  text-align: left;
  ${media.down("desktop")} {
    width: auto;
    margin-top: 25px;
  }
`;

export const StyledImageContainer = styled.div``;

export const StyledImage = styled(Image).attrs({ width: 1500, height: 800 })`
  height: 100%;
  width: 100%;
`;
